export enum LobActivityStudentsPerimissions {
  MboMyStudents = 'mbo-my-students',
  AdminMyStudents = 'admin-my-students'
}
